import React from 'react';

const IntegerFmt = ({ children }) => {
    // Convert children to an integer
    const numberStr = children;
    let formattedNumber;

    try {
        const parsedNumber = parseInt(numberStr, 10);
        
        // Check if the parsed value is a valid integer
        if (isNaN(parsedNumber)) {
            throw new Error('Invalid integer');
        }

        // Format the integer with commas for thousands
        formattedNumber = parsedNumber.toLocaleString('en-US');
    } catch (error) {
        console.error(error);
        return <span>Invalid integer</span>;
    }

    return (
        <span className="integer-format">{formattedNumber}</span>
    );
};

export default IntegerFmt;